<div class="blackout-rule-form" [attr.data-testid]="'blackout-rule-form-' + index">

  <p class="blackout-hint" *ngIf="timezone">
    Times below are in <strong>{{ timezone }}</strong>.
  </p>

  <div class="blackout-field blackout-rule-name-field">
    <label class="label is-small" [attr.for]="'blackout-rule-' + index + '-name-input'">Rule name <span class="blackout-optional">(optional)</span></label>
    <input
      class="input is-small blackout-rule-name-input"
      type="text"
      [disabled]="disabled"
      [ngModel]="range.name || ''"
      (ngModelChange)="setRuleName($event)"
      placeholder="e.g. Weeknight blackout"
      maxlength="255"
      [id]="'blackout-rule-' + index + '-name-input'"
      [attr.data-testid]="'blackout-rule-' + index + '-name'"
     data-ui-name="E g weeknight blackout" data-ui-component="blackout-hours-rule-form" aria-label="e.g. Weeknight blackout"/>
  </div>

  <div class="blackout-field">
    <label class="label is-small" [id]="'blackout-rule-' + index + '-repeats-label'">Repeats on</label>
    <div class="blackout-dow" role="group" [attr.aria-labelledby]="'blackout-rule-' + index + '-repeats-label'" data-ui-name="Blackout hours rule form div" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-blackout-hours-rule-form-div">
      <label *ngFor="let dow of BLACKOUT_DOW_PROPS" class="checkbox" [attr.title]="dow.caption">
        <input
          type="checkbox"
          [disabled]="disabled"
          [ngModel]="isDowChecked(dow.prop)"
          (ngModelChange)="setDowChecked(dow.prop, $event)"
          [attr.data-testid]="'blackout-rule-' + index + '-' + dow.prop"
         data-ui-name="Is dow checked(dow prop)" data-ui-component="blackout-hours-rule-form"/>
        {{ dow.short }}
      </label>
    </div>
    <div class="buttons are-small blackout-presets">
      <button type="button" class="button is-small is-light" [disabled]="disabled" (click)="setWeekdayPreset('weekdays')" data-ui-name="Mon–Fri" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-mon-fri">Mon–Fri</button>
      <button type="button" class="button is-small is-light" [disabled]="disabled" (click)="setWeekdayPreset('weekend')" data-ui-name="Sat–Sun" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-sat-sun">Sat–Sun</button>
      <button type="button" class="button is-small is-light" [disabled]="disabled" (click)="setWeekdayPreset('all')" data-ui-name="Every day" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-every-day">Every day</button>
      <button type="button" class="button is-small is-light" [disabled]="disabled" (click)="setWeekdayPreset('none')" data-ui-name="Clear" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-clear">Clear</button>
    </div>
  </div>

  <div class="blackout-field blackout-dates-field">
    <ng-container *ngIf="dateSectionOpen || hasDateValues(); else datesCollapsed">
      <label class="label is-small" [id]="'blackout-rule-' + index + '-dates-label'">Date range <span class="blackout-optional">(optional)</span></label>
      <div class="blackout-date-row" role="group" [attr.aria-labelledby]="'blackout-rule-' + index + '-dates-label'" data-ui-name="Start date End date" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-start-date-end-date">
        <div class="blackout-date-field">
          <span class="blackout-sub-label">Start date</span>
          <blackout-date-dropdown
            [value]="range.date_start"
            [disabled]="disabled"
            [testIdPrefix]="'blackout-rule-' + index + '-date-start'"
            ariaLabel="Start date"
            (valueChange)="onDateStartChange($event)"
           data-ui-name="Blackout date dropdown" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-blackout-date-dropdown"></blackout-date-dropdown>
        </div>
        <div class="blackout-date-field">
          <span class="blackout-sub-label">End date</span>
          <blackout-date-dropdown
            [value]="range.date_end"
            [disabled]="disabled"
            [testIdPrefix]="'blackout-rule-' + index + '-date-end'"
            ariaLabel="End date"
            (valueChange)="onDateEndChange($event)"
           data-ui-name="Blackout date dropdown" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-blackout-date-dropdown-92de0f8"></blackout-date-dropdown>
        </div>
      </div>
      <div class="buttons are-small">
        <button type="button" class="button is-small is-light" [disabled]="disabled" *ngIf="hasDateValues()" (click)="clearDates()" data-ui-name="Clear dates" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-clear-dates">Clear dates</button>
        <button type="button" class="button is-small is-text" [disabled]="disabled" *ngIf="!hasDateValues()" (click)="hideDateSection()" data-ui-name="Hide dates" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-hide-dates">Hide dates</button>
      </div>
    </ng-container>
    <ng-template #datesCollapsed>
      <button type="button" class="button is-small is-light" [disabled]="disabled" (click)="openDateSection()" data-ui-name="+ Limit to specific dates" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-limit-to-specific-dates">+ Limit to specific dates</button>
    </ng-template>
  </div>

  <div class="blackout-field">
    <label class="label is-small" [id]="'blackout-rule-' + index + '-hours-label'">Hours</label>

    <label class="checkbox blackout-all-day-toggle">
      <input
        type="checkbox"
        [disabled]="disabled"
        [ngModel]="isAllDayMode()"
        (ngModelChange)="setAllDayMode($event)"
        [attr.data-testid]="'blackout-rule-' + index + '-all-day'"
       data-ui-name="All day" data-ui-component="blackout-hours-rule-form"/>
      All day
    </label>

    <p class="blackout-hint" *ngIf="isAllDayMode()">
      Non-working for the full day on matching days or dates.
    </p>

    <div class="blackout-time-row" *ngIf="!isAllDayMode()" role="group" [attr.aria-labelledby]="'blackout-rule-' + index + '-hours-label'" data-ui-name="From Until" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-from-until">
      <div class="blackout-time-field">
        <span class="blackout-sub-label">From</span>
        <blackout-time-dropdown
          [value]="range.time_start"
          [disabled]="disabled"
          [testIdPrefix]="'blackout-rule-' + index + '-time-start'"
            ariaLabel="From"
          (valueChange)="onTimeChange('time_start', $event)"
         data-ui-name="Blackout time dropdown" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-blackout-time-dropdown"></blackout-time-dropdown>
      </div>
      <div class="blackout-time-field">
        <span class="blackout-sub-label">Until</span>
        <blackout-time-dropdown
          [value]="range.time_end"
          [disabled]="disabled"
          [testIdPrefix]="'blackout-rule-' + index + '-time-end'"
            ariaLabel="Until"
          (valueChange)="onTimeChange('time_end', $event)"
         data-ui-name="Blackout time dropdown" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-blackout-time-dropdown-97d8c13"></blackout-time-dropdown>
      </div>
    </div>

    <p class="blackout-hint" *ngIf="!isAllDayMode()">
      Times use 24-hour clock in 15-minute steps. An end time earlier than the start time runs overnight.
    </p>
  </div>

  <div class="blackout-field blackout-scope-field">
    <ng-container *ngIf="scopeSectionOpen || hasScopeValues(); else scopeCollapsed">
      <label class="label is-small">Pause scope <span class="blackout-optional">(optional)</span></label>
      <p class="blackout-hint is-size-7">
        Limit this rule to selected batch policies, assessment items, or scorers. Leave all unchecked to apply to everyone on the window.
      </p>
      <div class="blackout-scope-group" *ngIf="scopePickerOptions?.batch_alloc_policies?.length">
        <span class="blackout-sub-label">Batch allocation policies</span>
        <div class="blackout-scope-list" role="group" aria-label="Batch allocation policies" data-ui-name="Batch allocation policies" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-batch-allocation-policies">
          <label class="checkbox" *ngFor="let row of scopePickerOptions.batch_alloc_policies">
            <input
              type="checkbox"
              [disabled]="disabled"
              [checked]="isScopeChecked('scope_batch_alloc_policy_ids', row.id)"
              (change)="toggleScope('scope_batch_alloc_policy_ids', row.id)"
             data-ui-name="Toggle Scope" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-toggle-scope" [attr.data-entity-key]="row.id" data-entity-type="row"/>
            {{ policyLabel(row) }}
          </label>
        </div>
      </div>
      <div class="blackout-scope-group" *ngIf="scopePickerOptions?.marking_window_items?.length">
        <span class="blackout-sub-label">Assessment items</span>
        <div class="blackout-scope-list" role="group" aria-label="Assessment items" data-ui-name="Assessment items" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-assessment-items">
          <label class="checkbox" *ngFor="let row of scopePickerOptions.marking_window_items">
            <input
              type="checkbox"
              [disabled]="disabled"
              [checked]="isScopeChecked('scope_marking_window_item_ids', row.id)"
              (change)="toggleScope('scope_marking_window_item_ids', row.id)"
             data-ui-name="Toggle Scope" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-toggle-scope-976e6d6" [attr.data-entity-key]="row.id" data-entity-type="row"/>
            {{ itemLabel(row) }}
          </label>
        </div>
      </div>
      <div class="blackout-scope-group" *ngIf="scopePickerOptions?.scorers?.length">
        <span class="blackout-sub-label">Scorers</span>
        <div class="blackout-scope-list" role="group" aria-label="Scorers" data-ui-name="Scorers" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-scorers">
          <label class="checkbox" *ngFor="let row of scopePickerOptions.scorers">
            <input
              type="checkbox"
              [disabled]="disabled"
              [checked]="isScopeChecked('scope_scorer_uids', row.uid)"
              (change)="toggleScope('scope_scorer_uids', row.uid)"
             data-ui-name="Toggle Scope" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-toggle-scope-e75aa22" [attr.data-entity-key]="row.uid" data-entity-type="row"/>
            {{ scorerLabel(row) }}
          </label>
        </div>
      </div>
      <p class="blackout-hint is-size-7" *ngIf="!scopePickerOptions?.batch_alloc_policies?.length && !scopePickerOptions?.marking_window_items?.length && !scopePickerOptions?.scorers?.length">
        No policies, items, or scorers were found for this scoring window yet.
      </p>
      <div class="buttons are-small">
        <button type="button" class="button is-small is-light" [disabled]="disabled" *ngIf="hasScopeValues()" (click)="clearScope()" data-ui-name="Clear scope" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-clear-scope">Clear scope</button>
        <button type="button" class="button is-small is-text" [disabled]="disabled" *ngIf="!hasScopeValues()" (click)="hideScopeSection()" data-ui-name="Hide scope" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-hide-scope">Hide scope</button>
      </div>
    </ng-container>
    <ng-template #scopeCollapsed>
      <button type="button" class="button is-small is-light" [disabled]="disabled" (click)="openScopeSection()" data-ui-name="+ Limit to policies, items, or scorers" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-limit-to-policies-items-or-scorers">+ Limit to policies, items, or scorers</button>
    </ng-template>
  </div>

  <div class="blackout-field">
    <label class="label is-small" [id]="'blackout-rule-' + index + '-applies-label'">Applies to</label>
    <div class="blackout-tasks" role="group" [attr.aria-labelledby]="'blackout-rule-' + index + '-applies-label'" data-ui-name="Blackout hours rule form div" data-ui-component="blackout-hours-rule-form" data-testid="blackout-hours-rule-form-blackout-hours-rule-form-div-blackout-hours-rule-form-div">
      <label class="checkbox" *ngFor="let task of markingTaskOptions">
        <input
          type="checkbox"
          [disabled]="disabled"
          [checked]="isTaskChecked(task.id)"
          (change)="toggleTask(task.id)"
          [attr.data-testid]="'blackout-rule-' + index + '-task-' + task.id"
         data-ui-name="Toggle Task" data-ui-component="blackout-hours-rule-form" [attr.data-entity-key]="task.id" data-entity-type="task"/>
        {{ task.caption }}
      </label>
    </div>
  </div>

  <p role="alert" class="blackout-error" *ngIf="validateRange(range)" [attr.data-testid]="'blackout-rule-error-' + index" data-ui-name="Validate Range(range)" data-ui-component="blackout-hours-rule-form">
    {{ validateRange(range) }}
  </p>
</div>
